import React from 'react'
import TableManagementLayout from '../pages/table-management/TableManagementLayout'

export const TableManagement = () => {
  return <TableManagementLayout/>;
  
}
